var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-btn',{staticClass:"mt-2",attrs:{"large":"","depressed":"","color":"primary","href":"https://numazu-distillery.stores.jp"}},[_vm._v(" オンラインストアに移動 "),_c('v-icon',{staticClass:"ml-1",attrs:{"small":""}},[_vm._v(" mdi-cart-outline ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }